export default "__VITE_ASSET__vQu0WbO0__"